import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import LogoNCSA from "../img/logo-ncsa.png";
import LogoCyber from "../img/logo-cybre.png";
import LogoWhite from "../img/logo-ncsa-white.png";
import LogoCyberWhite from "../img/logo-cybre-white.png";
import IconSearch from "../img/icons/icon-search.svg";
import IconMoon from "../img/icons/icon-moon.svg";
import IconSun from "../img/icons/icon-sun.svg";
import IconUser from "../img/icons/icon-user.svg";
import * as Utils from "./Utils";
import { jwtDecode } from "jwt-decode";

export default function Header(prop) {
    let navigate = useNavigate();

    let [lang, setLang] = React.useState('th');
    let urlSegment1 = window.location.pathname;

    let [member, setMember] = React.useState(null);
    let [memberType, setMemberType] = React.useState(null);

    React.useEffect(() => {

        let memberJson = null;
        let memberTokens = localStorage.getItem(Utils.LOCAL_STORAGE_KEY);
        if(memberTokens) {
            memberJson = jwtDecode(JSON.parse(memberTokens).accessToken);
            let checkExpireHrs = (Math.abs(new Date().getTime() - new Date(memberJson.latestLoginAt).getTime()) / 3600000);
            if(checkExpireHrs > Utils.HOURS_EXPIRE_LOGIN) {
                localStorage.removeItem(Utils.LOCAL_STORAGE_KEY);
                setMember(null);
            }
            else {
                setMember(jwtDecode(memberJson.accessToken));
            }
        }

        let split = urlSegment1.split('/');
        let lang = split[1];
        if(lang === 'en') {
            setLang(lang);
        }

        (async function() {
            try {
                if(memberJson) {
                    const resMemberType = await Utils.getMemberType();
                    setMemberType(resMemberType.filter(e => e.id === memberJson.memberTypeId)[0].title);
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    function changeLang(selectLang) {
        let hostUrl = window.location.protocol + '//' + window.location.host;
        if(selectLang === 'en') {
            if(lang !== 'en') {
                window.location.href = hostUrl + '/en' + (urlSegment1 !== '/' ? urlSegment1:'');
            }
        }
        else {
            if(lang !== 'th') {
                window.location.href = hostUrl + urlSegment1.replace('/en', '');
            }
        }
    }

    const logOut = () => {
        localStorage.removeItem(Utils.LOCAL_STORAGE_KEY);
        window.location.replace((lang === 'en' ? '/en':'/') + 'login');
    };

    return (
        <>
            <header className="header">
                <div className="container">
                    <div className="navbar-brand">
                        <NavLink to={lang === 'en' ? '/en':'/'}>
                            <img className="logo-1" src={LogoNCSA} alt="" />
                                <img className="logo-2" src={LogoCyber} alt="" />
                        </NavLink>

                        <NavLink to="/">
                            <img className="logo-1" src={LogoWhite} alt="" />
                                <img className="logo-2" src={LogoCyberWhite} alt="" />
                        </NavLink>
                    </div>

                    <ul className="nav nav-main">
                        <li className={urlSegment1 == '/' || urlSegment1 == '/eb' ? 'active':''}><NavLink to={lang === 'en' ? '/en':'/'}><span className="line-animate">{lang === 'en' ? 'Home':'หน้าหลัก'}</span></NavLink>
                        </li>
                        <li className={(urlSegment1.indexOf('about') > 0 || urlSegment1.indexOf('vision') > 0) ? 'dropdown active':'dropdown'}>
                            <a data-bs-toggle="dropdown" data-bs-display="static" href="#"><span
                                className="line-animate">{lang === 'en' ? 'About':'เกี่ยวกับหน่วยงาน'}</span></a>
                            <ul className="dropdown-menu">
                                <li><NavLink to={lang === 'en' ? '/en/about':'/about'}>{lang === 'en' ? 'About us':'เกี่ยวกับ สกมช.'}</NavLink></li>
                                <li><NavLink to={lang === 'en' ? '/en/vision':'/vision'}>{lang === 'en' ? 'Visionand Mission':'วิสัยทัศน์ และพันธกิจ'}</NavLink></li>
                            </ul>
                        </li>
                        <li className={"dropdown" + (urlSegment1.indexOf('research') > 0 || urlSegment1.indexOf('researcher') > 0 || urlSegment1.indexOf('agency') > 0 || urlSegment1.indexOf('entrepreneur') > 0 ? ' active':'')}>
                            <a data-bs-toggle="dropdown" data-bs-display="static" href="#"><span
                                className="line-animate">{lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</span></a>
                            <ul className="dropdown-menu">
                                <li><NavLink to={lang === 'en' ? '/en/research':'/research'}>{lang === 'en' ? 'Research':'ข้อมูลผลงานวิจัย'}</NavLink></li>
                                <li><a href={lang === 'en' ? '/en/researcher':'/researcher'}>{lang === 'en' ? 'researcher':'ข้อมูลนักวิจัย'}</a></li>
                                <li><a href={lang === 'en' ? '/en/agency':'/agency'}>{lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน'}</a></li>
                                <li><NavLink to={lang === 'en' ? '/en/entrepreneur':'/entrepreneur'}>{lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ'}</NavLink></li>
                            </ul>
                        </li>
                        <li className={urlSegment1.indexOf('scholarship') > 0 ? 'active':''}><NavLink to={lang === 'en' ? '/en/' + (member ? 'scholarship':'login'): (member ? '/scholarship':'/login')}><span className="line-animate">{lang === 'en' ? 'Scholarship':'ทุนวิจัย'}</span></NavLink></li>
                        <li className={urlSegment1.indexOf('news') > 0 ? 'active':''}><NavLink to={lang === 'en' ? '/en/news':'/news'}><span className="line-animate">{lang === 'en' ? 'News':'ข่าวสาร'}</span></NavLink></li>
                        <li className={urlSegment1.indexOf('contact') > 0 ? 'active':''}><NavLink to={lang === 'en' ? '/en/contact':'/contact'}><span className="line-animate">{lang === 'en' ? 'Contact us':'ติดต่อเรา'}</span></NavLink></li>
                    </ul>

                    <ul className="nav nav-genaral">
                        <li>
                            <a className="btn btn-trans" href="#">
                                <img className="svg-js icons" src={IconSearch} alt="" />
                            </a>
                        </li>
                        <li>
                            <button className="btn btn-trans btn-theme-toggle" type="button">
                                <img className="svg-js icons moon" src={IconMoon} alt="" />
                                    <img className="svg-js icons sun" src={IconSun} alt="" />
                            </button>
                        </li>
                        <li className="dropdown lang">
                            <a data-bs-toggle="dropdown" data-bs-display="static" href="#"><span
                                className="line-animate">{lang.toUpperCase()}</span></a>
                            <ul className="dropdown-menu">
                                <li><a href="#" onClick={e => changeLang('en')}>EN</a></li>
                                <li><a href="#" onClick={e => changeLang('th')}>TH</a></li>
                            </ul>
                        </li>
                        <li className="dropdown">
                            {
                                member !== null && member.id > 0 ?
                                    <>
                                        <a href="#" className="btn btn-username d-none d-sm-flex" data-bs-toggle="dropdown" data-bs-display="static">
                                            <span className="name">{member.firstname + ' '  + member.lastname}</span>
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li><NavLink to={lang === 'en' ? '/en/profile':'/profile'}>{lang === 'en' ? 'Profile':'โปรไฟล์'}</NavLink></li>
                                            <li><NavLink to={lang === 'en' ? '/en/proposal':'/proposal'}> {lang === 'en' ? 'Project Proposal':'ข้อเสนอโครงการ'}</NavLink></li>
                                            <li><NavLink to={lang === 'en' ? '/en/proposalApprove':'/proposalApprove'}> {lang === 'en' ? 'Allocated Projects':'โครงการที่ได้รับจัดสรร'}</NavLink></li>
                                            <li><NavLink to={lang === 'en' ? '/en/proposalResult':'/proposalResult'}> {lang === 'en' ? 'Report Results':'รายงานผลลัพธ์'}</NavLink></li>
                                            <li><a href="#" onClick={logOut}>{lang === 'en' ? 'Logout':'ออกจากระบบ'}</a></li>
                                        </ul>

                                        <div className="dropdown d-block d-sm-none">
                                            <a className="btn btn-trans arrow-none" data-bs-toggle="dropdown"
                                               data-bs-display="static" href="#">
                                                <img className="svg-js icons" src={IconUser} alt="" />
                                            </a>

                                            <ul className="dropdown-menu member">
                                                <li><a href="#">{member.firstname + ' '  + member.lastname}</a></li>
                                            </ul>
                                        </div>
                                    </> :
                                    <>
                                        <NavLink to="/login" className="btn btn-light d-none d-sm-flex">
                                            {lang === 'en' ? 'Sign In/Sign Up':'เข้าสู่ระบบ/สมัครสมาชิก'}
                                        </NavLink>
                                        <div className="dropdown d-block d-sm-none">
                                            <a className="btn btn-trans arrow-none" data-bs-toggle="dropdown"
                                               data-bs-display="static" href="#">
                                                <img className="svg-js icons" src={IconUser} alt="" />
                                            </a>

                                            <ul className="dropdown-menu member">
                                                <li><NavLink to="/login">{lang === 'en' ? 'Sign In/Sign Up':'เข้าสู่ระบบ/สมัครสมาชิก'}</NavLink></li>
                                            </ul>
                                        </div>
                                    </>
                            }
                        </li>

                        <li>
                            <button className="btn btn-icon navbar-toggle" type="button">
                                <span className="group">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </li>
                    </ul>
                </div>
            </header>

            <div className="navbar-slider">
                <ul className="nav nav-main mainmenu">
                    <li><NavLink to={lang === 'en' ? '/en':'/'}>{lang === 'en' ? 'Home':'หน้าหลัก'}</NavLink></li>
                    <li className="dropdown level-1">
                        <a href="#" data-bs-toggle="dropdown" data-bs-display="static">{lang === 'en' ? 'About us':'เกี่ยวกับหน่วยงาน'}</a>
                        <ul className="dropdown-menu">
                            <li className="nav-title"><span className="arrow"></span> {lang === 'en' ? 'About us':'เกี่ยวกับหน่วยงาน'}</li>
                            <li><NavLink to={lang === 'en' ? '/en/about':'/about'}>{lang === 'en' ? 'About us':'เกี่ยวกับ สกมช.'}</NavLink></li>
                            <li><NavLink to={lang === 'en' ? '/en/vision':'/vision'}>{lang === 'en' ? 'Vision':'วิสัยทัศน์ และพันธกิจ'}</NavLink></li>
                        </ul>
                    </li>
                    <li className="dropdown level-1">
                        <a href="#" data-bs-toggle="dropdown" data-bs-display="static">{lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</a>
                        <ul className="dropdown-menu">
                            <li className="nav-title"><span className="arrow"></span> {lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</li>
                            <li><NavLink to={lang === 'en' ? '/en/research':'/research'}>{lang === 'en' ? 'Research':'ข้อมูลผลงานวิจัย'}</NavLink></li>
                            <li><NavLink to={lang === 'en' ? '/en/researcher':'/research'}>{lang === 'en' ? 'researcher':'ข้อมูลนักวิจัย'}</NavLink></li>
                            <li><NavLink to={lang === 'en' ? '/en/agency':'/agency'}>{lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน'}</NavLink></li>
                            <li><NavLink to={lang === 'en' ? '/en/entrepreneur':'/entrepreneur'}>{lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ'}</NavLink></li>
                        </ul>
                    </li>
                    <li><NavLink to={lang === 'en' ? '/en/research':'/research'}>{lang === 'en' ? 'Research funding':'ทุนวิจัย'}</NavLink></li>
                    <li><NavLink to={lang === 'en' ? '/en/news':'/news'}>{lang === 'en' ? 'News':'ข่าวสาร'}</NavLink></li>
                    <li><NavLink to={lang === 'en' ? '/en/contact':'/contact'}>{lang === 'en' ? 'Contact us':'ติดต่อเรา'}</NavLink></li>
                </ul>
            </div>
        </>
    );
} 